import { Component, signal } from '@angular/core';
import { RouterLink } from '@angular/router';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faFacebook, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faAngleRight, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-footer',
  imports: [FaIconComponent, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

  //#region Copyright Properties
  year: number = new Date().getFullYear();
  //#endregion
  
  //#region Icons
  iconRight = faAngleRight;

  iconEnvelope = faEnvelope;
  iconPhone = faPhone;

  iconFacebook = faFacebook;
  iconInstagram = faInstagram;
  iconTiktok = faTiktok;
  //#endregion

}
